import {
    Component,
    ComponentFactoryResolver,
    Inject,
    Injector,
    OnDestroy,
    OnInit,
    StaticProvider,
    ViewContainerRef,
} from '@angular/core';

import { WidgetConfiguration } from '../../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../../widget/widget.metadata';
import { CoachingInsightWidgetService } from '../oa/services/coaching-insight.widget.service';
import { CoachingService } from '../oa/services/coaching.service';
import { ElasticUIService } from '../oa/services/elastic-ui.service';
import { FrontlineOAService } from '../oa/services/frontline-oa.service';
import { PersonOfInterestService } from '../oa/services/person-of-interest.service';
import { TeamOAService } from '../oa/services/team-oa.service';
import { StickyHeaderService } from '../stickyheader/stickyheader.service';

import { OldCoachingInsightWidgetComponent } from './coaching-insight.widget.component';
import { OldCoachingInsightWidgetService } from './services/coaching-insight.widget.service';
import { OldCoachingService } from './services/coaching.service';
import { OldElasticUIService } from './services/elastic-ui.service';
import { OldFrontlineOAService } from './services/frontline-oa.service';
import { OldPersonOfInterestService } from './services/person-of-interest.service';
import { OldTeamOAService } from './services/team-oa.service';

@Component({
    selector: 'cmps-oa-widget-wrapper',
    template: '',
})
export class OaWidgetWrapperComponent implements OnInit, OnDestroy {
    constructor(
        private readonly _factoryResolver: ComponentFactoryResolver,
        private readonly _injector: Injector,
        private readonly _viewContainerRef: ViewContainerRef,
        @Inject(CMPS_WIDGET_CONFIG)
        private readonly _config: WidgetConfiguration,
    ) {}

    ngOnInit(): void {
        const providers: StaticProvider[] = [
            {
                provide: CoachingInsightWidgetService,
                useExisting: OldCoachingInsightWidgetService,
            },
            {
                provide: TeamOAService,
                useExisting: OldTeamOAService,
            },
            {
                provide: FrontlineOAService,
                useExisting: OldFrontlineOAService,
            },
            {
                provide: CoachingService,
                useExisting: OldCoachingService,
            },
            {
                provide: PersonOfInterestService,
                useExisting: OldPersonOfInterestService,
            },
            {
                provide: ElasticUIService,
                useExisting: OldElasticUIService,
            },
            {
                // yes this needs to be provided at the component level
                provide: StickyHeaderService,
                useClass: StickyHeaderService,
                deps: [],
            },
        ];

        const inj = Injector.create({
            providers,
            parent: this._injector,
        });

        const factory = this._factoryResolver.resolveComponentFactory(
            OldCoachingInsightWidgetComponent,
        );

        this._viewContainerRef.createComponent(factory, null, inj);
    }

    ngOnDestroy(): void {
        this._viewContainerRef.remove();
    }
}
